// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file error_codes.proto (package domainerr, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file error_codes.proto.
 */
export const file_error_codes: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from enum domainerr.ErrorGroup
 */
export enum ErrorGroup {
  /**
   * @generated from enum value: EG_UNDEFINED = 0;
   */
  EG_UNDEFINED = 0,

  /**
   * @generated from enum value: EG_UNSPECIFIC = 10000;
   */
  EG_UNSPECIFIC = 10000,

  /**
   * @generated from enum value: EG_ACCOUNT = 20000;
   */
  EG_ACCOUNT = 20000,

  /**
   * @generated from enum value: EG_CREDENTIAL = 30000;
   */
  EG_CREDENTIAL = 30000,

  /**
   * @generated from enum value: EG_AUTHENTICATOR = 40000;
   */
  EG_AUTHENTICATOR = 40000,

  /**
   * @generated from enum value: EG_VAULT = 50000;
   */
  EG_VAULT = 50000,

  /**
   * @generated from enum value: EG_ORGANIZATION = 60000;
   */
  EG_ORGANIZATION = 60000,

  /**
   * @generated from enum value: EG_PROFILE = 70000;
   */
  EG_PROFILE = 70000,

  /**
   * @generated from enum value: EG_INTEGRATION = 80000;
   */
  EG_INTEGRATION = 80000,

  /**
   * @generated from enum value: EG_AUDITLOG = 90000;
   */
  EG_AUDITLOG = 90000,

  /**
   * @generated from enum value: EG_WEBAUTHN = 100000;
   */
  EG_WEBAUTHN = 100000,

  /**
   * @generated from enum value: EG_SHARELINK = 110000;
   */
  EG_SHARELINK = 110000,

  /**
   * @generated from enum value: EG_USER_CONFIRMATION = 120000;
   */
  EG_USER_CONFIRMATION = 120000,
}

/**
 * Describes the enum domainerr.ErrorGroup.
 */
export const ErrorGroupSchema: GenEnum<ErrorGroup> = /*@__PURE__*/
  enumDesc(file_error_codes, 0);

/**
 * Error codes used to identify error cases by the client.
 * Let's make them somewhat easy to remember:
 *
 * + 4xx: something not found (think HTTP 404)
 *
 * Order by error group and numeric value to avoid conflicts.
 *
 * @generated from enum domainerr.ErrorCode
 */
export enum ErrorCode {
  /**
   * @generated from enum value: UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * Unspecific
   *
   * @generated from enum value: PERMISSION_DENIED = 10100;
   */
  PERMISSION_DENIED = 10100,

  /**
   * @generated from enum value: TIMEOUT = 10200;
   */
  TIMEOUT = 10200,

  /**
   * @generated from enum value: CANCELED = 10300;
   */
  CANCELED = 10300,

  /**
   * @generated from enum value: BAD_REQUEST = 10400;
   */
  BAD_REQUEST = 10400,

  /**
   * @generated from enum value: CLIENT_OUTDATED = 10426;
   */
  CLIENT_OUTDATED = 10426,

  /**
   * @generated from enum value: INTERNAL = 10500;
   */
  INTERNAL = 10500,

  /**
   * @generated from enum value: UNAVAILABLE = 10503;
   */
  UNAVAILABLE = 10503,

  /**
   * Account
   *
   * @generated from enum value: EMAIL_TAKEN = 20100;
   */
  EMAIL_TAKEN = 20100,

  /**
   * @generated from enum value: INVALID_EMAIL = 20101;
   */
  INVALID_EMAIL = 20101,

  /**
   * @generated from enum value: EMAIL_ALREADY_VERIFIED = 20102;
   */
  EMAIL_ALREADY_VERIFIED = 20102,

  /**
   * @generated from enum value: EMAIL_REQUIRED = 20103;
   */
  EMAIL_REQUIRED = 20103,

  /**
   * @generated from enum value: INVALID_LOCALE = 20105;
   */
  INVALID_LOCALE = 20105,

  /**
   * @generated from enum value: EMAIL_INVITE_NOT_ACTIVE = 20106;
   */
  EMAIL_INVITE_NOT_ACTIVE = 20106,

  /**
   * @generated from enum value: EMAIL_TAKEN_NOT_RECOVERABLE = 20107;
   */
  EMAIL_TAKEN_NOT_RECOVERABLE = 20107,

  /**
   * @generated from enum value: MALFORMED_USER_SETTINGS = 20108;
   */
  MALFORMED_USER_SETTINGS = 20108,

  /**
   * @generated from enum value: EMAIL_TAKEN_VERIFIED_DOMAIN = 20109;
   */
  EMAIL_TAKEN_VERIFIED_DOMAIN = 20109,

  /**
   * @generated from enum value: EMAIL_TAKEN_ORG_ADMIN_RECOVERABLE = 20110;
   */
  EMAIL_TAKEN_ORG_ADMIN_RECOVERABLE = 20110,

  /**
   * @generated from enum value: USER_NOT_FOUND = 20400;
   */
  USER_NOT_FOUND = 20400,

  /**
   * @generated from enum value: SESSION_NOT_FOUND = 20410;
   */
  SESSION_NOT_FOUND = 20410,

  /**
   * @generated from enum value: INVALID_TIMEOUT = 20420;
   */
  INVALID_TIMEOUT = 20420,

  /**
   * no longer in use
   *
   * @generated from enum value: SESSION_ALREADY_UNLOCKED = 20430;
   */
  SESSION_ALREADY_UNLOCKED = 20430,

  /**
   * @generated from enum value: SESSION_NOT_UNLOCKED = 20431;
   */
  SESSION_NOT_UNLOCKED = 20431,

  /**
   * @generated from enum value: INVITATION_NOT_FOUND = 20450;
   */
  INVITATION_NOT_FOUND = 20450,

  /**
   * @generated from enum value: PROFILES_LOCKED = 20451;
   */
  PROFILES_LOCKED = 20451,

  /**
   * @generated from enum value: INVALID_VERIFICATION_TOKEN = 20460;
   */
  INVALID_VERIFICATION_TOKEN = 20460,

  /**
   * @generated from enum value: NOT_ALLOWED_FOR_USER_TYPE = 20470;
   */
  NOT_ALLOWED_FOR_USER_TYPE = 20470,

  /**
   * @generated from enum value: MALFORMED_CLIENT_SETTINGS = 20480;
   */
  MALFORMED_CLIENT_SETTINGS = 20480,

  /**
   * @generated from enum value: MALFORMED_DEVICE_INFO = 20481;
   */
  MALFORMED_DEVICE_INFO = 20481,

  /**
   * @generated from enum value: INVALID_UNLOCK_TIME_LIMIT = 20482;
   */
  INVALID_UNLOCK_TIME_LIMIT = 20482,

  /**
   * @generated from enum value: REGISTER_USE_LEGACY = 20500;
   */
  REGISTER_USE_LEGACY = 20500,

  /**
   * Credential
   *
   * @generated from enum value: MISSING_CREDENTIALS = 30100;
   */
  MISSING_CREDENTIALS = 30100,

  /**
   * @generated from enum value: INVALID_SIGNATURE = 30400;
   */
  INVALID_SIGNATURE = 30400,

  /**
   * @generated from enum value: INVALID_CHALLENGE = 30410;
   */
  INVALID_CHALLENGE = 30410,

  /**
   * @generated from enum value: INVALID_CREDENTIALS = 30420;
   */
  INVALID_CREDENTIALS = 30420,

  /**
   * @generated from enum value: CHALLENGE_USER_MISMATCH = 30430;
   */
  CHALLENGE_USER_MISMATCH = 30430,

  /**
   * @generated from enum value: LONG_POLL_CHANNEL_NOT_FOUND = 30440;
   */
  LONG_POLL_CHANNEL_NOT_FOUND = 30440,

  /**
   * @generated from enum value: LONG_POLL_CHANNEL_ALREADY_EXISTS = 30441;
   */
  LONG_POLL_CHANNEL_ALREADY_EXISTS = 30441,

  /**
   * @generated from enum value: INVALID_USER_SWITCH = 30450;
   */
  INVALID_USER_SWITCH = 30450,

  /**
   * @generated from enum value: INVALID_SESSION_TYPE = 30460;
   */
  INVALID_SESSION_TYPE = 30460,

  /**
   * @generated from enum value: BROWSER_MANAGED_DEVICE_TOKEN_INVALID = 30470;
   */
  BROWSER_MANAGED_DEVICE_TOKEN_INVALID = 30470,

  /**
   * Authenticator
   *
   * @generated from enum value: AUTHENTICATOR_BLOCK_OUT_OF_SYNC = 40100;
   */
  AUTHENTICATOR_BLOCK_OUT_OF_SYNC = 40100,

  /**
   * @generated from enum value: AUTHENTICATOR_NOT_FOUND = 40400;
   */
  AUTHENTICATOR_NOT_FOUND = 40400,

  /**
   * @generated from enum value: AUTHENTICATOR_CHANNEL_NOT_FOUND = 40410;
   */
  AUTHENTICATOR_CHANNEL_NOT_FOUND = 40410,

  /**
   * @generated from enum value: AUTHENTICATOR_CHANNEL_ALREADY_CLAIMED = 40411;
   */
  AUTHENTICATOR_CHANNEL_ALREADY_CLAIMED = 40411,

  /**
   * @generated from enum value: NO_AUTHENTICATOR_OPERATION = 40420;
   */
  NO_AUTHENTICATOR_OPERATION = 40420,

  /**
   * @generated from enum value: MISSING_AUTHENTICATOR_BLOCK = 40430;
   */
  MISSING_AUTHENTICATOR_BLOCK = 40430,

  /**
   * @generated from enum value: AUTHENTICATOR_BLOCK_NOT_FOUND = 40440;
   */
  AUTHENTICATOR_BLOCK_NOT_FOUND = 40440,

  /**
   * @generated from enum value: AUTHENTICATOR_BLOCK_EXISTS = 40450;
   */
  AUTHENTICATOR_BLOCK_EXISTS = 40450,

  /**
   * @generated from enum value: INVALID_AUTHENTICATOR_TYPE = 40460;
   */
  INVALID_AUTHENTICATOR_TYPE = 40460,

  /**
   * @generated from enum value: INVALID_RECIPIENT = 40500;
   */
  INVALID_RECIPIENT = 40500,

  /**
   * Vault
   *
   * @generated from enum value: VAULT_OUT_OF_SYNC = 50100;
   */
  VAULT_OUT_OF_SYNC = 50100,

  /**
   * @generated from enum value: NOT_ALLOWED_FOR_VAULT = 50110;
   */
  NOT_ALLOWED_FOR_VAULT = 50110,

  /**
   * @generated from enum value: VAULT_INSUFFICIENT_ACCESS = 50120;
   */
  VAULT_INSUFFICIENT_ACCESS = 50120,

  /**
   * @generated from enum value: EMPTY_COMMIT = 50200;
   */
  EMPTY_COMMIT = 50200,

  /**
   * @generated from enum value: VAULT_NOT_FOUND = 50400;
   */
  VAULT_NOT_FOUND = 50400,

  /**
   * @generated from enum value: CONFLICTING_VAULT_EXISTS = 50401;
   */
  CONFLICTING_VAULT_EXISTS = 50401,

  /**
   * @generated from enum value: MISSING_VAULT_AUTHENTICATOR_LOCK = 50410;
   */
  MISSING_VAULT_AUTHENTICATOR_LOCK = 50410,

  /**
   * @generated from enum value: MISSING_VAULT_PROFILE_LOCK = 50411;
   */
  MISSING_VAULT_PROFILE_LOCK = 50411,

  /**
   * @generated from enum value: MISSING_VAULT = 50420;
   */
  MISSING_VAULT = 50420,

  /**
   * @generated from enum value: INVALID_UPDATE_TIME = 50430;
   */
  INVALID_UPDATE_TIME = 50430,

  /**
   * @generated from enum value: INVALID_VAULT_TYPE = 50431;
   */
  INVALID_VAULT_TYPE = 50431,

  /**
   * @generated from enum value: MALFORMED_LOGIN_MAINTENANCE_CRITERIA = 50432;
   */
  MALFORMED_LOGIN_MAINTENANCE_CRITERIA = 50432,

  /**
   * @generated from enum value: MISSING_VAULT_ADMIN = 50440;
   */
  MISSING_VAULT_ADMIN = 50440,

  /**
   * @generated from enum value: VAULT_DIRTY = 50450;
   */
  VAULT_DIRTY = 50450,

  /**
   * @generated from enum value: MISSING_ENCRYPTED_VAULT_MESSAGE_PRIVATE_KEY = 50460;
   */
  MISSING_ENCRYPTED_VAULT_MESSAGE_PRIVATE_KEY = 50460,

  /**
   * @generated from enum value: MISSING_VAULT_MESSAGE_PUBLIC_KEY = 50461;
   */
  MISSING_VAULT_MESSAGE_PUBLIC_KEY = 50461,

  /**
   * @generated from enum value: UNHANDLED_VAULT_MESSAGE = 50462;
   */
  UNHANDLED_VAULT_MESSAGE = 50462,

  /**
   * @generated from enum value: INVALID_VAULT_MESSAGE_TYPE = 50463;
   */
  INVALID_VAULT_MESSAGE_TYPE = 50463,

  /**
   * @generated from enum value: VAULT_MESSAGE_NOT_FOUND = 50464;
   */
  VAULT_MESSAGE_NOT_FOUND = 50464,

  /**
   * @generated from enum value: VAULT_INBOX_SLUG_INVALID = 50470;
   */
  VAULT_INBOX_SLUG_INVALID = 50470,

  /**
   * @generated from enum value: VAULT_INBOX_SLUG_TAKEN = 50471;
   */
  VAULT_INBOX_SLUG_TAKEN = 50471,

  /**
   * @generated from enum value: VAULT_MEMBER_SYNC_OUTDATED = 50472;
   */
  VAULT_MEMBER_SYNC_OUTDATED = 50472,

  /**
   * Organization
   *
   * @generated from enum value: ORGANIZATION_INSUEFFICIENT_ACCESS = 60100;
   */
  ORGANIZATION_INSUEFFICIENT_ACCESS = 60100,

  /**
   * @generated from enum value: NOT_ALLOWED_FOR_ORGANIZATION = 60101;
   */
  NOT_ALLOWED_FOR_ORGANIZATION = 60101,

  /**
   * @generated from enum value: ORGANIZATION_NOT_FOUND = 60400;
   */
  ORGANIZATION_NOT_FOUND = 60400,

  /**
   * ignored at the moment
   *
   * @generated from enum value: USER_ALREADY_IN_ORGANIZATION = 60401;
   */
  USER_ALREADY_IN_ORGANIZATION = 60401,

  /**
   * @generated from enum value: ORGANIZATION_MISSING_ADMIN = 60410;
   */
  ORGANIZATION_MISSING_ADMIN = 60410,

  /**
   * @generated from enum value: INVALID_ORGANIZATION_NAME = 60430;
   */
  INVALID_ORGANIZATION_NAME = 60430,

  /**
   * @generated from enum value: ORGANIZATION_INVALID_CONTACT = 60431;
   */
  ORGANIZATION_INVALID_CONTACT = 60431,

  /**
   * @generated from enum value: COUPON_INVALID = 60440;
   */
  COUPON_INVALID = 60440,

  /**
   * @generated from enum value: COUPON_ALREADY_REDEEMED = 60441;
   */
  COUPON_ALREADY_REDEEMED = 60441,

  /**
   * @generated from enum value: COUPON_INCOMPATIBLE = 60442;
   */
  COUPON_INCOMPATIBLE = 60442,

  /**
   * @generated from enum value: OTHER_PROFILE_EMAIL_CONFLICTS = 60450;
   */
  OTHER_PROFILE_EMAIL_CONFLICTS = 60450,

  /**
   * @generated from enum value: INVALID_ORGANIZATION_DELETION_TOKEN = 60460;
   */
  INVALID_ORGANIZATION_DELETION_TOKEN = 60460,

  /**
   * @generated from enum value: MALFORMED_PASSWORD_POLICY = 60470;
   */
  MALFORMED_PASSWORD_POLICY = 60470,

  /**
   * @generated from enum value: MALFORMED_PARENT_ORGANIZATION_METADATA = 60471;
   */
  MALFORMED_PARENT_ORGANIZATION_METADATA = 60471,

  /**
   * @generated from enum value: MALFORMED_ENTRA_SETTINGS = 60472;
   */
  MALFORMED_ENTRA_SETTINGS = 60472,

  /**
   * @generated from enum value: LICENSE_COUNT_EXCEEDED = 60480;
   */
  LICENSE_COUNT_EXCEEDED = 60480,

  /**
   * @generated from enum value: INVALID_LICENSE = 60481;
   */
  INVALID_LICENSE = 60481,

  /**
   * @generated from enum value: ROLE_NOT_FOUND = 61404;
   */
  ROLE_NOT_FOUND = 61404,

  /**
   * @generated from enum value: INVALID_ROLE = 61405;
   */
  INVALID_ROLE = 61405,

  /**
   * @generated from enum value: NOT_ALLOWED_FOR_ROLE = 61406;
   */
  NOT_ALLOWED_FOR_ROLE = 61406,

  /**
   * Profile
   *
   * @generated from enum value: PROFILE_NOT_FOUND = 70400;
   */
  PROFILE_NOT_FOUND = 70400,

  /**
   * @generated from enum value: PROFILE_ALREADY_ENABLED = 70401;
   */
  PROFILE_ALREADY_ENABLED = 70401,

  /**
   * @generated from enum value: PROFILE_ALREADY_CONNECTED = 70402;
   */
  PROFILE_ALREADY_CONNECTED = 70402,

  /**
   * @generated from enum value: PROFILE_STARTCODE_INACTIVE = 70403;
   */
  PROFILE_STARTCODE_INACTIVE = 70403,

  /**
   * @generated from enum value: MISSING_PROFILE_AUTHENTICATOR_LOCK = 70410;
   */
  MISSING_PROFILE_AUTHENTICATOR_LOCK = 70410,

  /**
   * @generated from enum value: PROFILE_OUT_OF_SYNC = 70411;
   */
  PROFILE_OUT_OF_SYNC = 70411,

  /**
   * @generated from enum value: MISSING_PROFILE_PROFILE_LOCK = 70412;
   */
  MISSING_PROFILE_PROFILE_LOCK = 70412,

  /**
   * @generated from enum value: START_CODE_INVALID = 70430;
   */
  START_CODE_INVALID = 70430,

  /**
   * @generated from enum value: START_CODE_BLOCKED = 70431;
   */
  START_CODE_BLOCKED = 70431,

  /**
   * @generated from enum value: START_CODE_MISSING = 70432;
   */
  START_CODE_MISSING = 70432,

  /**
   * @generated from enum value: NOT_ALLOWED_FOR_PROFILE = 70433;
   */
  NOT_ALLOWED_FOR_PROFILE = 70433,

  /**
   * Integrations
   *
   * @generated from enum value: INTEGRATION_NOT_INITIALIZED = 80400;
   */
  INTEGRATION_NOT_INITIALIZED = 80400,

  /**
   * @generated from enum value: INTEGRATION_UNAUTHORIZED = 80401;
   */
  INTEGRATION_UNAUTHORIZED = 80401,

  /**
   * @generated from enum value: INTEGRATION_USER_NOT_FOUND = 80402;
   */
  INTEGRATION_USER_NOT_FOUND = 80402,

  /**
   * @generated from enum value: INTEGRATION_GROUP_NOT_FOUND = 80403;
   */
  INTEGRATION_GROUP_NOT_FOUND = 80403,

  /**
   * @generated from enum value: INTEGRATION_DATA_NOT_AVAILABLE = 80404;
   */
  INTEGRATION_DATA_NOT_AVAILABLE = 80404,

  /**
   * @generated from enum value: INTEGRATION_INTERNAL = 80500;
   */
  INTEGRATION_INTERNAL = 80500,

  /**
   * Auditlog
   *
   * @generated from enum value: AUDITLOG_MALFORMED_EVENT = 90400;
   */
  AUDITLOG_MALFORMED_EVENT = 90400,

  /**
   * @generated from enum value: AUDITLOG_ADMIN_INVALID_CREDENTIALS = 90420;
   */
  AUDITLOG_ADMIN_INVALID_CREDENTIALS = 90420,

  /**
   * @generated from enum value: AUDITLOG_WRITE_INVALID_CREDENTIALS = 90421;
   */
  AUDITLOG_WRITE_INVALID_CREDENTIALS = 90421,

  /**
   * @generated from enum value: AUDITLOG_SUBMISSION_ERROR = 90500;
   */
  AUDITLOG_SUBMISSION_ERROR = 90500,

  /**
   * WebAuthn
   *
   * @generated from enum value: WEBAUTHN_VALIDATE_ERROR = 100400;
   */
  WEBAUTHN_VALIDATE_ERROR = 100400,

  /**
   * @generated from enum value: WEBAUTHN_DATA_ERROR = 100401;
   */
  WEBAUTHN_DATA_ERROR = 100401,

  /**
   * @generated from enum value: WEBAUTHN_REQUEST_NOT_FOUND = 100402;
   */
  WEBAUTHN_REQUEST_NOT_FOUND = 100402,

  /**
   * @generated from enum value: WEBAUTHN_INVALID_TRANSPORT = 100403;
   */
  WEBAUTHN_INVALID_TRANSPORT = 100403,

  /**
   * @generated from enum value: MISSING_WEBAUTHN_CREDENTIAL = 100404;
   */
  MISSING_WEBAUTHN_CREDENTIAL = 100404,

  /**
   * @generated from enum value: MISSING_WEBAUTHN_RESPONSE = 100405;
   */
  MISSING_WEBAUTHN_RESPONSE = 100405,

  /**
   * @generated from enum value: WEBAUTHN_MISSING_USER_VERIFICATION = 100406;
   */
  WEBAUTHN_MISSING_USER_VERIFICATION = 100406,

  /**
   * ShareLink
   *
   * @generated from enum value: SHARE_LINK_NOT_FOUND = 110400;
   */
  SHARE_LINK_NOT_FOUND = 110400,

  /**
   * UserConfirmation
   *
   * @generated from enum value: USER_CONFIRMATION_NOT_FOUND = 120400;
   */
  USER_CONFIRMATION_NOT_FOUND = 120400,
}

/**
 * Describes the enum domainerr.ErrorCode.
 */
export const ErrorCodeSchema: GenEnum<ErrorCode> = /*@__PURE__*/
  enumDesc(file_error_codes, 1);

